<form [formGroup]="configurationFormFileName">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="fileFormat"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.file-format'
        |
        translate}}</label>
      <app-enum-drop-down-list formControlName="fileFormat"
                               [showClearButton]="false"
                               [enumType]="FileFormat"
                               baseTranslationString='i18n.shared.fileFormats.'>
      </app-enum-drop-down-list>
    </div>
    <div class="form-group col-md-4">
      <label for="titleInFile"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.generate-title'
        |
        translate}}</label>
      <input id="titleInFile"
             type="text"
             class="form-control"
             formControlName="titleInFile"/>
    </div>
    <div class="form-group col-md-4">
      <label for="noOfDecimalPlaces"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.no-of-decimal-places'
        |
        translate}}</label>
      <ejs-numerictextbox id="noOfDecimalPlaces"
                          formControlName="noOfDecimalPlaces"
                          format="n0"
                          min="0"
                          max="3">
      </ejs-numerictextbox>
      <app-error-messages [control]="configurationFormFileName.get('noOfDecimalPlaces')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="includeXmlDeclaration"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.include-xml-declaration' | translate}}</label>
      <app-yes-no-group-button id="includeXmlDeclaration"
                               formControlName="includeXmlDeclaration">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="xmlRootTag"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.root-tag'
        |
        translate}}</label>
      <input id="xmlRootTag"
             type="text"
             class="form-control"
             formControlName="xmlRootTag"/>
      <app-error-messages [control]="configurationFormFileName.get('xmlRootTag')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="elementTag"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.element-tag'
        |
        translate}}</label>
      <input id="elementTag"
             type="text"
             class="form-control"
             formControlName="elementTag"/>
      <app-error-messages [control]="configurationFormFileName.get('elementTag')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="seperator"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.separator' | translate}}</label>
      <app-enum-drop-down-list formControlName="seperator"
                               [showClearButton]="false"
                               [enumType]="Separator"
                               baseTranslationString='i18n.shared.separators.'>
      </app-enum-drop-down-list>
    </div>
    <div class="form-group col-md-4">
      <label for="textFormat"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.text-format' | translate}}</label>
      <app-enum-drop-down-list formControlName="textFormat"
                               [showClearButton]="false"
                               [enumType]="TextFormat"
                               baseTranslationString='i18n.shared.textFormats.'>
      </app-enum-drop-down-list>
    </div>
    <div class="form-group col-md-4">
      <label for="fileExtension"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.file-extension' | translate}}</label>
      <input id="fileExtension"
             type="text"
             class="form-control"
             formControlName="fileExtension"
             pattern="^[A-Za-z0-9]+$"
             appAlphanumericDirective/>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="decimalSeperator"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.decimal-seperator'
        |
        translate}}</label>
      <app-enum-drop-down-list formControlName="decimalSeperator"
                               [showClearButton]="false"
                               [enumType]="DecimalSeparator"
                               baseTranslationString='i18n.shared.decimalSeparators.'>
      </app-enum-drop-down-list>
    </div>
    <div class="form-group col-md-4">
      <label for="currency"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.currency-code'
        |
        translate}}</label>
      <app-enum-drop-down-list formControlName="currency"
                               [showClearButton]="false"
                               [enumType]="Currency"
                               baseTranslationString='i18n.shared.currencies.'>
      </app-enum-drop-down-list>
    </div>
    <div class="form-group col-md-4">
      <label for="processType"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.process-type' | translate}}</label>
      <app-enum-drop-down-list formControlName="processType"
                               [showClearButton]="false"
                               [enumType]="ProcessType"
                               baseTranslationString='i18n.shared.fileProcessTypes.'>
      </app-enum-drop-down-list>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="csvEnQuoteValues"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.csv-enquote-values' | translate}}</label>
      <app-yes-no-group-button id="csvEnQuoteValues"
                               formControlName="csvEnQuoteValues">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="suppressHeaderLineInCsv"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.csv-suppress-headerline' | translate}}</label>
      <app-yes-no-group-button id="suppressHeaderLineInCsv"
                               formControlName="suppressHeaderLineInCsv">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="generateEndLineInCsv"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.form-fields.csv-generate-endline' | translate}}</label>
      <app-yes-no-group-button id="generateEndLineInCsv"
                               formControlName="generateEndLineInCsv">
      </app-yes-no-group-button>
    </div>
  </div>
</form>
<hr/>
<app-configuration-form-file-name-placeholder></app-configuration-form-file-name-placeholder>
